// extracted by mini-css-extract-plugin
module.exports = {"clouds":"Clouds_clouds__2IN2G","svg":"Clouds_svg__3H5nb"};